import { useSaveWeekSettingsChanges } from "../hooks";
import {
    CheckboxWrapper,
    CustomButton,
    FooterWrapper,
} from "./StyledComponents";
import { useDispatch, useSelector } from "../../store/store";
import { isOddWeekUsed, toggleOddWeekUsed } from "../../store/data";
import { useTranslation } from "react-i18next";
import useCalendar from "../../calendar/context/useCalendar";

interface Props {
    closeModal: () => void;
    isRegular: boolean;
}

const Footer = ({ closeModal, isRegular }: Props) => {
    const { inputCallbacks } = useCalendar();
    const dispatch = useDispatch();
    const saveWeekSettingsChanges = useSaveWeekSettingsChanges(
        closeModal,
        isRegular
    );
    const oddWeekUsed = useSelector(isOddWeekUsed);
    const { t } = useTranslation();

    const handleClick = () => {
        saveWeekSettingsChanges();
        //inputCallbacks.onChangeConsultationClose && inputCallbacks.onChangeConsultationClose()
    };

    const handleChange = () => {
        dispatch(toggleOddWeekUsed());
    };

    return (
        <FooterWrapper>
            {isRegular && (
                <CheckboxWrapper>
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="isOddWeekUsed"
                        checked={oddWeekUsed}
                        onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="isOddWeekUsed">
                        {t("use_odd_week")}
                    </label>
                </CheckboxWrapper>
            )}
            <div style={{ width: "100%" }}>
                <CustomButton onClick={handleClick}>
                    {t("save").toUpperCase()}
                </CustomButton>
            </div>
        </FooterWrapper>
    );
};

export default Footer;
